import { render } from "./ProfitLossAnalyticsTable.vue?vue&type=template&id=f22a5a90&scoped=true"
import script from "./ProfitLossAnalyticsTable.vue?vue&type=script&lang=js"
export * from "./ProfitLossAnalyticsTable.vue?vue&type=script&lang=js"

import "./ProfitLossAnalyticsTable.vue?vue&type=style&index=0&id=f22a5a90&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22a5a90"]])

export default __exports__